export const OVERVIEW_ID = "overview";
export const INVESTORS_TYPE = "Investors";
const SALES_TYPE = "Sales";
export const RECOMMENDATIONS_NUMBER = 20;
export const FEED_TAB = "FEED_TAB";
export const DASHBOARDS_TAB = "DASHBOARDS_TAB";
export const ANALYSIS_TAB = "ANALYSIS_TAB";
const FEED_FEEDBACK_POSITIVE = "positive";
const FEED_FEEDBACK_NEGATIVE = "negative";
export const LIST_SETTING_INFO = "info";
export const LIST_SETTING_FEED = "feed";
